import { ParsedErrorResponse } from 'src/types/fetch';
/**
 * convert Api Error with new spec if external SRC is supported
 * @param {object} parsedData parsed API error
 * @return {object} errorResponse with new Spec
 *
 * See https://visawiki.trusted.visa.com/pages/viewpage.action?pageId=297137004 for more information
 *
 * TODO: add more specific error checking logic once each API/case error response is available 11/2018
 * General:
 *      1. UNKNOWN_ERROR (done)
 *      2. REQUEST_TIMEOUT (done)
 *      3. SERVER_ERROR (done)
 *      4. INVALID_PARAMETER (done)
 *      5. INVALID_REQUEST (done)
 *      6. AUTH_ERROR (done)
 *      7. NOT_FOUND (done)
 *      8. RATE_LIMIT_EXCEEDED (done)
 *      9. SERVICE_ERROR (done)
 */
export default function getGenericError<R extends ParsedErrorResponse<object>>(response: R) {
  switch (response.httpStatus) {
    case 400:
      // some parameter in request is not valid or is not verified
      return 'INVALID_PARAMETER';
    case 401:
      // CVV or OTP check failed; other risk check failures
      return 'AUTH_ERROR';
    case 404:
      // something is not found (intentId, user, paymentInstrument)
      return 'NOT_FOUND';
    case 408:
      return 'REQUEST_TIMEOUT';
    case 409:
      // duplicate updateIntent request but with a different addressId or paymentInstrumetnId
      return 'INVALID_REQUEST';
    case 423:
    case 429:
      // Risk / DFM denial due to exceeding number of requests in a certain time period
      return 'RATE_LIMIT_EXCEEDED';
    case 500:
      // service cannot be called; unable to retrieve intent/user/card/merchant info, etc.; data-transformation or other error
      return 'SERVER_ERROR';
    case 503:
      return 'SERVICE_ERROR';
    default:
      return 'UNKNOWN_ERROR';
  }
}
